module.exports = __webpack_public_path__ + "img/beer_id-80.f90565af.png";